import EditVoucher from './EditVoucher';
import VoucherList from './VoucherList';
import VoucherType from './voucherType/VoucherType';
import VoucherTypeForm from './voucherType/VoucherTypeForm';

const VoucherConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/voucher',
      element: <VoucherList />,
    },
    {
      path: '/voucherTypes',
      element: <VoucherType />,
    },
    {
      path: '/editVoucher/:id',
      element: <EditVoucher />,
    },
    {
      path: '/addVoucherType',
      element: <VoucherTypeForm />,
    },
    {
      path: '/editVoucherType/:id',
      element: <VoucherTypeForm />,
    },
    {
      path: '/addVoucher',
      element: <EditVoucher />,
    },
    {
      path: '/viewVoucher/:viewid',
      element: <EditVoucher />,
    },
  ],
};

export default VoucherConfig;
